import CompensationQuote from "../components/compensations/CompensationQuote";
import ModalContent from "../components/modal/ModalContent";
import { SharedModalProps } from "../components/modal/ModalContextProvider";

const CompensationQuoteModal = ({
  handleClose,
  quote,
  userName,
}: SharedModalProps<{
  quote: string;
  userName: string;
}>) => {
  return (
    <ModalContent label={userName} onClose={handleClose}>
      <CompensationQuote quote={quote} userName={userName} />
    </ModalContent>
  );
};

export default CompensationQuoteModal;
